import styled from "styled-components";

type Classification = "A" | "B" | "C" | "Q";

const classificationColors: { [key in Classification]: string } = {
  A: "green",
  B: "orange",
  C: "red",
  Q: "purple",
};

const ClassificationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ClassificationButton = styled.button<{
  selected: boolean;
  classification: Classification;
}>`
  flex: 1;
  padding: 12px;
  font-size: 18px;
  font-weight: bold;
  border: 2px solid ${(props) => classificationColors[props.classification]};
  border-radius: 8px;
  cursor: pointer;
  margin: 0 8px;
  color: ${(props) =>
    props.selected ? "white" : classificationColors[props.classification]};
  background-color: ${(props) =>
    props.selected ? classificationColors[props.classification] : "white"};
  transition: all 0.2s ease;
`;

function Classifications({
  classification,
  handleSubmit,
}: {
  classification: Classification | null;
  handleSubmit: (classification: Classification) => void;
}) {
  return (
    <ClassificationContainer>
      <h4>CLASSIFICATION:</h4>
      <div>
        {(["A", "B", "C", "Q"] as Classification[]).map(
          (classificationButton) => (
            <ClassificationButton
              key={classificationButton}
              selected={classification === classificationButton}
              onClick={() => handleSubmit(classificationButton)}
              classification={classificationButton}
            >
              {classificationButton}
            </ClassificationButton>
          )
        )}
      </div>
    </ClassificationContainer>
  );
}

export default Classifications;
